import { RoleName } from "../types";

export const ApplicantDepartmentId = "applicants";
export const RetiredDepartmentId = "retired";
export const RoleNames = Object.values(RoleName).reduce((a, b, i) => {
  a[b] = ["システム管理者", "クライアント管理者", "部署オーナー", "参照のみ"][i];
  return a;
}, {} as { [key: string]: string });
export const GraphColors = ["rgba(255, 128, 140, 1)", "rgba(128, 140, 255, 1)", "rgba(106, 230, 92, 1)"];
export const PersonalityDetailGroupTooltip = {
  Physical: {
    high: "強み：身軽、活発に行動<br/>弱み：考えずに行動してしまう、じっとしていられない",
    low: "強み：騒がしくない<br/>弱み：モタモタしている印象、腰が重い"
  },
  Emotional: {
    high: "強み：そのときの気分に反したことはしない<br/>弱み：気分の浮き沈みが激しい、気分で行動",
    low: "強み：落ち着きがある<br/>弱み：腰が重い"
  },
  Persistency: {
    high: "強み：几帳面、長続き、粘り強い<br/>弱み：しつこい、順応性が低い",
    low: "強み：切り替えが早い、あっさりしている<br/>弱み：飽きっぽい、諦めが早い"
  },
  Regulality: {
    high: "強み：誠実、ルールを守る、決まりを大切にする<br/>弱み：発想が定型的、頑固、融通が利かない",
    low: "強み：自由に考えることができる、柔軟性がある<br/>弱み：決まりに従わない"
  },
  Competitive: {
    high: "強み：勝気、負けず嫌い、外に打って出る<br/>弱み：言い過ぎてしまうことが多い",
    low: "強み：争いごとを好まない、マイペース<br/>弱み：殻を破って一歩外に出るということがない"
  },
  SelfRespective: {
    high: "強み：好き嫌いをはっきり言える、自信家<br/>弱み：甘えん坊、未成熟、わがまま",
    low: "強み：嫌なことも我慢できる、穏やか<br/>弱み：内面にストレスを溜めやすい、弱気になりやすい"
  },
  Carefull: {
    high: "強み：先の見通しをつける<br/>弱み：何をするにも時間がかかる",
    low: "強み：思い切りがいい<br/>弱み：うっかりミスが多い、軽率"
  },
  Timid: {
    high: "強み：失敗をしないように気をつけている<br/>弱み：ビクビクしている、精神的に不安定",
    low: "強み：過ぎたことは気にしない<br/>弱み：見落としが多い"
  },
  Introversive: {
    high: "強み：内省的、自分を見つめている、職人気質<br/>弱み：社交意識が低い、内向的、対人接触を好まない",
    low: "強み：物事を行動で解決しようとする、対人面で積極的、交際範囲が広い<br/>弱み：落ち着きがない"
  },
  Objective: {
    high: "強み：冷静、論理的、思慮深い<br/>弱み：相手と距離を置く、冷淡、屁理屈",
    low: "強み：感情表現が豊か<br/>弱み：考え深くない"
  }
} as const;
export const SocialityTooltip = {
  積極性: {
    high: "強み：自ら提案、率先して行動<br/>弱み：人の意見を聞く前に動いてしまう、聞こえない",
    low: "強み：担当以外のことに口出ししない<br/>弱み：指示されないと動かない、遠慮がち、消極的"
  },
  協調性: {
    high: "強み：仲間に協力的、共通の目標を目指す<br/>弱み：事なかれ主義になりやすい",
    low: "強み：自分の意見を主張できる<br/>弱み：意見が衝突、対人関係で問題、独断的"
  },
  責任感: {
    high: "強み：発言や仕事に責任、仕事や役割を理解<br/>弱み：一度はじめたことに縛られる",
    low: "強み：気軽に引き受ける<br/>弱み：途中で投げ出す、完遂できない"
  },
  自己信頼性: {
    high: "強み：自信がある、周囲から信頼される<br/>弱み：自分が正しいという思い込み",
    low: "強み：場の雰囲気を読み取る<br/>弱み：周りに合わせて意見を変える、状況に左右される"
  },
  指導性: {
    high: "強み：頼りにされる、意見や行動をまとめる<br/>弱み：自分がいいと思ったやり方でどんどん仕切ってしまう",
    low: "強み：主張するより合わせられる<br/>弱み：他人にわかりやすく説明するのが下手指示待ち"
  },
  共感性: {
    high: "強み：仲間と同じ立場で考える、みなの意見や考えを大切にする、共同作業に熱心<br/>弱み：主流意見に簡単に同意する",
    low: "強み：一人で行動できる<br/>弱み：独自の志向が強い、意思の疎通を欠く"
  },
  感情安定性: {
    high: "強み：気持ちにムラがない、多少のことでは動揺しない<br/>弱み：何を考えているのかわかりにくい",
    low: "強み：喜怒哀楽がはっきりしている<br/>弱み：多少のことで動揺する"
  },
  従順性: {
    high: "強み：反抗的でない、素直<br/>弱み：勧められるままに受け入れる",
    low: "強み：周囲に流されない<br/>弱み：強く言われると反感を持つ"
  },
  自主性: {
    high: "強み：自分で判断、自発的に行動<br/>弱み：他の人の意見を聞こうとしない",
    low: "強み：勝手な行動を起こさない<br/>弱み：指示を待って動く、大任にうろたえる"
  },
  ﾓﾗﾄﾘｱﾑ傾向: {
    high: "強み：人の意見に耳を傾ける<br/>弱み：何事にも意欲が湧かず、元気がない",
    low: "強み：自信があり安定<br/>弱み：自信過剰"
  }
} as const;

export const ActivityMotivationDetailTooltip = {
  達成欲求: {
    high: "強み：目標に向かって努力する<br/>弱み：他者に厳しい",
    low: "強み：現実を受け入れる<br/>弱み：無欲で目標が見出せない"
  },
  自律欲求: {
    high: "強み：主体的に生きる、頼るより自力で頑張る<br/>弱み：既成の価値観や通念に反発",
    low: "強み：困ったときは助けを求められる<br/>弱み：人を当てにする"
  },
  求知欲求: {
    high: "強み：変化を求める、新しいことに挑戦<br/>弱み：興味が次々と移る、落ち着きがない",
    low: "強み：安定を求める、目移りしない<br/>弱み：変化を受け入れない、現状に満足"
  },
  危機耐性: {
    high: "強み：苦しいときもやり抜く、自我を忘れない<br/>弱み：他人に頼ることができない",
    low: "強み：危ないことに首を突っ込まない<br/>弱み：緊急場面では自分を見失う、力を発揮できない"
  },
  勤労意欲: {
    high: "強み：仕事に意欲がある、仕事を通して自己実現<br/>弱み：犠牲を考えない",
    low: "強み：割り切りがよい<br/>弱み：生活手段としての勤務、あまり動きたくない"
  },
  顕示欲求: {
    high: "強み：人を楽しませたい、目立ちたい<br/>弱み：周囲から浮いてしまう",
    low: "強み：静かで落ち着いている<br/>弱み：おとなしく目立たない"
  },
  支配欲求: {
    high: "強み：周囲を動かしていい方向にもっていきたい<br/>弱み：他人を動かしたい",
    low: "強み：穏やか<br/>弱み：人の上に立つことに消極的"
  },
  親和欲求: {
    high: "強み：仲良くしたい、援助したい<br/>弱み：傷のなめあい",
    low: "強み：実力と努力を大切にする<br/>弱み：能力重視で人柄軽視"
  },
  秩序欲求: {
    high: "強み：キチンとしていたい、整理整頓したい<br/>弱み：杓子定規、無理にルールに合わせようとする",
    low: "強み：変化に強く、創造性がある<br/>弱み：ルール・規則を気にしない"
  },
  物質的欲望: {
    high: "強み：モノを大切に扱い、作業全般が丁寧<br/>弱み：金銭、モノへの執着力が強い",
    low: "強み：モノに執着がない<br/>弱み：モノを粗末に扱う"
  }
} as const;
